import { useFeatureFlag } from "./useFeatureFlag";

/**
 * Render-time hook for whether the current user is in remix mode. Gates all
 * remix-only UI (the /starting-options cards, the /home/concepts/new "how it
 * works" row) so non-remix users keep the classic experience.
 *
 * Reads the same `remix_flow` flag as the routing in ConceptScheme.handleChatSubmit
 * so the onboarding UI a user sees lines up with the flow they are routed through.
 */
export function useRemixMode(): boolean {
  return useFeatureFlag("remix_flow");
}
